import { SidebarAccordionModule } from "../../Sidebar/Accordian";
import { ModuleBuyersCompensation } from "./ModuleBuyersCompensation";
import { ModuleCapitalExpenditures } from "./moduleCapitalExpenditures";
import { ModuleCompanySale } from "./ModuleCompanySale";
import { ModuleDealExpenses } from "./ModuleDealExpenses";
import { ModuleDepreciationAmortization } from "./moduleDepreciationAmortization";
import { ModuleEquityInvestorTerms } from "./ModuleEquityInvestorTerms/ModuleEquityInvestorTerms";
import { ModuleFinanceStructure } from "./ModuleFinanceStructure";
import { ModuleLenderLineOfCredit } from "./ModuleLenderLineOfCredit";
import { ModulePurchase } from "./ModulePurchase";
import { ModuleRealEstate } from "./ModuleRealEstate";
import { ModuleSBA7aLoan } from "./ModuleSBA7aLoan";
import { ModuleSellersNote } from "./ModuleSellersNote";
import { ModuleTaxes } from "./ModuleTaxes";
import { ModuleWorkingCapital } from "./ModuleWorkingCapital";

export const sidebarModules: SidebarAccordionModule[] = [
  ModulePurchase,
  ModuleRealEstate,
  ModuleFinanceStructure,
  ModuleEquityInvestorTerms,
  ModuleWorkingCapital,
  ModuleLenderLineOfCredit,
  ModuleDealExpenses,
  ModuleSBA7aLoan,
  ModuleSellersNote,
  ModuleCompanySale,
  ModuleBuyersCompensation,
  ModuleCapitalExpenditures,
  ModuleDepreciationAmortization,
  ModuleTaxes,
];
